var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.943,
    height: 44.661,
    viewBox: "0 0 147.943 44.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4756.491 8234.705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.911,271.182h0a19.011,19.011,0,1,1,0-38.022h16.176a2.835,2.835,0,0,1,2.834,2.834v16.176a19.014,19.014,0,0,1-19.011,19.011",
    transform: "translate(-4892.072 -8464.545)",
    fill: "#0066f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.911,271.182h0a19.011,19.011,0,1,1,0-38.022h16.176a2.835,2.835,0,0,1,2.834,2.834v16.176A19.014,19.014,0,0,1,157.911,271.182Z",
    transform: "translate(-4892.072 -8464.545)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6.639
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4704.387 -8219.751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.408,268.182c-1.639,0-2.546.751-2.546,1.773-.022,1.137,1.13,1.65,2.51,1.968l1.426.339c2.755.617,4.745,2.018,4.752,4.662-.007,2.9-2.282,4.752-6.153,4.752-3.849,0-6.3-1.773-6.388-5.2h3.242c.108,1.589,1.361,2.39,3.105,2.39,1.7,0,2.8-.791,2.809-1.95-.007-1.069-.968-1.564-2.694-1.982l-1.726-.433c-2.679-.643-4.326-1.982-4.319-4.319-.014-2.878,2.531-4.8,6.008-4.8,3.531,0,5.853,1.95,5.9,4.777h-3.214C282.994,268.911,282.012,268.182,280.408,268.182Z",
    transform: "translate(-274.01 -265.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,281.835l5.474-15.855h4.319l5.463,15.855H323.2l-1.177-3.614h-5.719l-1.177,3.614Zm9.648-6.232-1.95-6h-.123l-1.95,6Z",
    transform: "translate(-297.989 -265.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.08,265.98h10.5v2.762h-7.146v3.777h6.449v2.762h-6.449v6.55H359.08Z",
    transform: "translate(-328.363 -265.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.388,268.182c-1.639,0-2.546.751-2.546,1.773-.022,1.137,1.13,1.65,2.51,1.968l1.426.339c2.755.617,4.745,2.018,4.752,4.662-.007,2.9-2.282,4.752-6.153,4.752-3.849,0-6.3-1.773-6.387-5.2h3.242c.108,1.589,1.361,2.39,3.105,2.39,1.7,0,2.8-.791,2.809-1.95-.007-1.069-.968-1.564-2.694-1.982l-1.726-.433c-2.679-.643-4.326-1.982-4.319-4.319-.014-2.878,2.531-4.8,6.008-4.8,3.531,0,5.853,1.95,5.9,4.777H402.1C401.974,268.911,400.992,268.182,399.388,268.182Z",
    transform: "translate(-350.029 -265.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.291,281.835H433.94V265.98h3.351Z",
    transform: "translate(-376.192 -265.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.017,265.974l4.366,10.652h.184l4.365-10.652h4.134v15.855h-3.25v-10.32h-.13l-4.1,10.24h-2.213l-4.1-10.28h-.13v10.356h-3.25V265.97h4.127Z",
    transform: "translate(-387.022 -265.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.1,268.182c-1.639,0-2.546.751-2.546,1.773-.022,1.137,1.13,1.65,2.509,1.968l1.426.339c2.755.617,4.745,2.018,4.752,4.662-.007,2.9-2.282,4.752-6.153,4.752-3.849,0-6.3-1.773-6.387-5.2h3.243c.108,1.589,1.361,2.39,3.105,2.39,1.7,0,2.8-.791,2.809-1.95-.007-1.069-.968-1.564-2.694-1.982l-1.726-.433c-2.679-.643-4.326-1.982-4.319-4.319-.014-2.878,2.531-4.8,6.008-4.8,3.531,0,5.853,1.95,5.9,4.777h-3.214C513.684,268.911,512.7,268.182,511.1,268.182Z",
    transform: "translate(-421.402 -265.38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.57,275.009h0a17.39,17.39,0,1,1,0-34.779h15.371a2.017,2.017,0,0,1,2.018,2.018V257.62a17.389,17.389,0,0,1-17.39,17.39",
    transform: "translate(-4892.251 -8469.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.723,297.321c7.872,8.626,15.667,7.98,23.412.311a.717.717,0,0,1,1.159.823c-1.672,3.578-5.275,8.341-12.555,8.6-7.951.282-11.605-5.124-13.2-8.908a.729.729,0,0,1,1.184-.823",
    transform: "translate(-4900.104 -8505.384)",
    fill: "#0066f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.9e7f49394896fb5b55c783f435f0368b.svg";
export { ForwardRef as ReactComponent };